module.exports = __webpack_public_path__ + "static/media/288aaea3-b9b4-4a84-a9a9-f466107b6bfe_1.eab5ac9ae082d8bd1649c4fe225a69df.a69ad258.jpeg";